module.exports = __webpack_public_path__ + "img/2021.39218962.jpg";